import { BranchGetOneUseCase } from '../../../../application';

export default class BranchGetOneService {
    
    async execute(event) {
        const data = await BranchGetOneUseCase(event);
        return data;
    }
}
